import mixpanel from "mixpanel-browser";

import {
  SOAP_FIELDS,
  CUSTOM_FIELDS,
  TEMPLATE_TYPES,
} from "./constants";

export const createNewTemplate = async (
  templateType,
  isFavourite = true,
  createAutoTemplate,
) => {
  const createTemplateInput = { templateType, isFavourite };

  if (templateType === TEMPLATE_TYPES.SOAP) {
    createTemplateInput.templateFields = SOAP_FIELDS;
  } else if (templateType === TEMPLATE_TYPES.CUSTOM) {
    createTemplateInput.templateFields = CUSTOM_FIELDS;
  }
  try {
    const response = await createAutoTemplate({
      variables: { createTemplateInput },
    });
    mixpanel.track("Create template button clicked", {
      templateType,
      templateUuid: response?.data?.createAutoTemplate?.templateUuid,
    });
    return response?.data?.createAutoTemplate?.templateUuid;
  } catch (error) {
    alert("error", "Error creating template. Please try again.");
    mixpanel.track("Template creation error", {
      error: error.message,
    });
  }
};
